import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, X } from "lucide-react";
import { Module, Lesson } from "@/lib/types";

interface LessonSidebarProps {
  courseSlug: string;
  currentLessonSlug: string;
  modules: Module[];
  lessons: Record<string, Lesson>;
  completedLessons: Record<string, boolean>;
  isMobile?: boolean;
  onCloseMobile?: () => void;
}

export function LessonSidebar({
  courseSlug,
  currentLessonSlug,
  modules,
  lessons,
  completedLessons,
  isMobile = false,
  onCloseMobile
}: LessonSidebarProps) {
  return (
    <div className={`p-4 ${isMobile ? "h-full overflow-y-auto" : ""}`}>
      {isMobile && (
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold">Course Content</h2>
          <button onClick={onCloseMobile}>
            <X className="h-5 w-5" />
          </button>
        </div>
      )}
      
      {!isMobile && (
        <h2 className="text-lg font-bold mb-4">Course Content</h2>
      )}
      
      <div className="space-y-4">
        {modules.sort((a, b) => a.position - b.position).map((module) => (
          <div key={module.id}>
            <h3 className="text-sm font-semibold text-muted-foreground mb-2">{module.title}</h3>
            <ul className="space-y-1">
              {(module.lessons || [])
                .sort((a, b) => a.position - b.position)
                .map((lesson) => (
                  <li key={lesson.slug}>
                    <Link
                      to={`/courses/${courseSlug}/${module.id}/${lesson.slug}`}
                      className={`flex items-center justify-between px-3 py-2 rounded-md transition-colors ${
                        currentLessonSlug === lesson.slug
                          ? "bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground"
                          : "hover:bg-muted hover:text-foreground"
                      }`}
                      onClick={isMobile ? onCloseMobile : undefined}
                    >
                      <span className="flex items-center">
                        {completedLessons[lesson.slug] && (
                          <Check className="h-3 w-3 mr-2 flex-shrink-0" />
                        )}
                        <span className="truncate">{lesson.title}</span>
                      </span>
                    </Link>
                  </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
